export const creativeShelter = {
  companyName: 'Creative Shelter BV',
  vatNumber: 'BE0536939936',
  iban: 'BE53 7370 3980 0153',
  addressLine1: 'Adolf Baeyensstraat 134 F',
  addressLine2: '9040 Gent',
};
